import { c as _c } from "react/compiler-runtime";
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';
export type BlockedComposerProps = {
  pills?: ReactNode;
  input: ReactNode;
  message: string;
};

// Radix is used directly (not the ui Tooltip) so the trigger can be the full-size overlay — the
// ui wrapper's inline-block trigger collapses to zero height and never receives hover.
const BlockedComposer = t0 => {
  const $ = _c(13);
  const {
    pills,
    input,
    message
  } = t0;
  let t1;
  if ($[0] !== pills) {
    t1 = pills && <div className="relative w-full flex justify-center">{pills}<div className="absolute inset-0 z-20 cursor-not-allowed" aria-hidden="true" /></div>;
    $[0] = pills;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TooltipPrimitive.Trigger asChild={true}><div data-testid="percy-blocked-overlay" className="absolute inset-0 z-20 cursor-not-allowed" aria-hidden="true" /></TooltipPrimitive.Trigger>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== input) {
    t3 = <div className="relative w-full">{input}{t2}</div>;
    $[3] = input;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== message) {
    t4 = <TooltipPrimitive.Portal><TooltipPrimitive.Content side="top" align="center" sideOffset={4} className="max-w-[300px] px-2 py-1 text-wrap text-caption-3 text-quinary text-left rounded bg-tertiary shadow-md z-50">{message}</TooltipPrimitive.Content></TooltipPrimitive.Portal>;
    $[5] = message;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <TooltipPrimitive.Provider delayDuration={0}><TooltipPrimitive.Root>{t3}{t4}</TooltipPrimitive.Root></TooltipPrimitive.Provider>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t5) {
    t6 = <div className="relative w-full flex flex-col items-center gap-4 md:gap-8">{t1}{t5}</div>;
    $[10] = t1;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default BlockedComposer;